import React, { useState } from 'react'
import PdfFlipModal from '../components/PdfFlipModal'

const GUIA_PDF_URL = 'https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/GUIAPARAFAMILIAS.pdf?alt=media&token=97ef5327-6f15-43ef-9163-82864ed2e8ca';

const Recomendaciones = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
        <div className='container fondotransparente p-5'>

            <center><h1 classname="p-5 botonbordeazul text-white px-5 mx-5 py-3">Recomendaciones Generales</h1></center>
            <br/>

            <center>
                <h2 className="botonbordeazul text-white px-5 py-3 mb-4">Guía para Familias</h2>
            </center>

            <div className="text-center mb-4">
                <button
                    onClick={() => setShowModal(true)}
                    className="btn btn-primary"
                >
                    Ver Guía para Familias
                </button>
            </div>

            <hr className="my-5" />

            <p>El uso de las Tecnologías de la Información y la Comunicación (TIC), ya sea Internet, las redes sociales, los videojuegos… conlleva unos riesgos tanto para nosotros como para nuestros hijos que no debemos despreciar ni minimizar, pero también nos ofrecen una gran variedad de beneficios o virtudes que ya estamos disfrutando en mayor o menor medida. El miedo a los riesgos no debe coartar nuestro disfrute y la utilidad de tales medios.</p>

            <p>Una gran función como padres y educadores debe ser ayudar a los adolescentes a desarrollar la habilidad prioritaria de la comunicación cara a cara, lo que, entre otras cosas supone:</p>

            <p>1. Limitar (no prohibir) el uso de aparatos y pactar las horas de uso del ordenador/compu/tablet.</p>

            <p>&nbsp;2. Fomentar la relación directa con otras personas.</p>

            <p>3. Potenciar aficiones tales como la lectura, el cine y otras actividades culturales y deportivas.</p>

            <p>&nbsp;4. Estimular el deporte y las actividades en equipo.</p>

            <p>5. Desarrollar actividades grupales</p>

            <p>&nbsp;6. Estimular la comunicación y el diálogo en la propia familia.</p>

            <p><strong>CONOCER, PROTEGER y EDUCAR</strong></p>

            <p>• CONOCER e identificar las ventajas que nos ofrecen los recursos tecnológicos y los riesgos que presenta.</p>

            <p>• PROTEGER a nuestras familias de los riesgos generados por un inadecuado uso de este tipo de recursos estableciendo normas para ello.</p>

            <p>• Todo ello sin olvidar que nuestra principal herramienta es la EDUCACIÓN ayudando a crear hábitos que faciliten un uso responsable de los medios.</p>

            <p><strong>MEDIDAS DE PROTECCIÓN A CONSIDERAR EN LA INFANCIA Y LA ADOLESCENCIA: </strong>Es importante que esta labor protectora comience en la INFANCIA con medidas como las siguientes:</p>

            <p>&nbsp;• Delimitar el número de horas que pueden dedicar a las nuevas tecnologías.</p>

            <p>• Evitar que dispongan de televisión u ordenador/computadora &nbsp;en su habitación, ya que las posibilidades de supervisión se reducen (si bien es cierto que los smartphones/celulares &nbsp;en este tema son difíciles de controlar).</p>

            <p>• Delimitar la edad a la que pueden disponer de teléfono móvil.</p>

            <p>&nbsp;• Definir con claridad normas respecto al tipo de programas de televisión que pueden ver, videojuegos para jugar o el tipo de páginas web a las que pueden acceder.</p>

            <p>&nbsp;• Observar la clasificación de los videojuegos antes de comprarlos.</p>

            <p>• Poner filtros en Internet.</p>

            <p>Navega y chatea de vez en cuando con tus hijos, así podrás conocer sus hábitos, preferencias y crearás un clima de mayor confianza entre USTEDES</p>

            <p><strong>Hablar sobre la posibilidad de que algún desconocido contacto con él/ella, haciendo hincapié en la importancia de no darle ningún dato personal</strong>. Es esencial que exista una buena comunicación en la familia, por si se da la ocurrencia de alguna incidencia, el/la &nbsp;adolescente pueda recurrir a los padres sin miedo o vergüenza.</p>

            <p>&nbsp;Evita que se conecten a Internet por la noche, especialmente a los chats.</p>

            <p>Procura alcanzar el nivel de habilidad informática de tus hijos. Es decir actualizate.</p>

            <p><strong>EDUCAR</strong></p>

            <p>&nbsp;Las normas son imprescindibles para proteger a niños/niñas. Sin embargo, resultan insuficientes si no logramos paralelamente que aprendan a controlar su propio consumo de TIC. Realmente, la mejor manera de protegerlos, especialmente en la adolescencia, consiste en ayudarles a que comprendan el funcionamiento de estas tecnologías, a que tengan criterio para seleccionar contenidos, para detectar las manipulaciones y otros riesgos, para ser capaces de estrategias educativas:</p>

            <p>&nbsp;• Educar a través del propio modelo. Debemos lograr que el modelo que transmitimos, nuestro propio estilo de utilización de la televisión, de otros medios audiovisuales y de comunicación, sea coherente con los objetivos que queremos lograr en nuestros hijos e hijas.</p>

            <p>• Explicarles el sentido de las normas que se aplican en la familia, en relación con los medios audiovisuales y las nuevas tecnologías de la comunicación. Aunque se rebelen y protesten contra ellas, seguro que en el fondo entienden que son necesarias.</p>

            <p>• Especialmente en la adolescencia,  como ya hemos comentado, también tiene un gran efecto educativo su participación en la determinación, modificación y/o negociación de las normas.</p>

            <p>• El diálogo. Cualquier espacio de diálogo con el o la adolescente es oro, por breve que sea. Para ello debemos crear oportunidades y prestar atención para aprovecharlas.</p>

            <p>En relación con el uso de las TIC, el visionado conjunto de un capítulo de su serie favorita, un rato de navegación por Internet o una partida con su videojuego preferido, pueden ser momentos clave para:</p>

            <p>• Conocer mejor sus opiniones, gustos y reacciones.</p>

            <p>&nbsp;• Transmitir nuestras propias opiniones y gustos. Debemos tener cuidado para expresarlas de manera respetuosa. Por otro lado, si las únicas opiniones que transmitimos son críticas con sus gustos, es posible que esto afecte negativamente a la relación educativa.</p>

            <p>• Debatir sobre el funcionamiento de las diversas tecnologías, sus aportaciones, sus ventajas, sus inconvenientes y sus riesgos.</p>

            <p><strong>VALORES Y AUTOESTIMA EN LA ADOLESCENCIA </strong></p>

            <p><strong>Si educamos en valores y enseñamos habilidades y estrategias</strong>&nbsp;para evitar el uso inadecuado de las nuevas tecnologías estaremos educando jóvenes sólidos con espíritu crítico y una buena base para tomar decisiones. Por ello, consideramos fundamental enseñar habilidades sociales y estrategias de solución de problemas. Si el/la &nbsp;joven desarrolla destrezas y habilidades adecuadas para interaccionar y relacionarse de forma adecuada en todos sus contextos, es menos probable que desarrolle&nbsp;adicción a las Nuevas Tecnologías.</p>

            <p>Por otro lado, la&nbsp;<strong>autoestima del adolescente es fundamental</strong>. Por ello, es importante que los padres apoyen al joven, evitando las críticas, valorando sus fortalezas y aspectos positivos. A veces, cuando el/la &nbsp;joven comete un error, los padres olvidan que está aprendiendo, recurren a juicios y críticas para solucionar el conflicto. No obstante, es necesario que se le enseñe a asumir las responsabilidades, a rectificar y a ser autónomo.</p>

            <p><strong>SEGURIDAD E INTERNET</strong>: Existen en el mercado programas que pueden instalarse en el ordenador y funcionar como filtro, bloqueando páginas web que contengan determinadas palabras, imágenes nocivas, etc.</p>

            <p>Al igual que ocurre en el caso del juego, las adicciones a las tecnologías (Internet, móvil, videojuegos TIC) tienen unos síntomas comunes muy característicos, tales como:</p>

            <p>a) Necesidad de uso creciente de la tecnología para conseguir los mismos beneficios que al inicio (tolerancia);</p>

            <p>b) Reacciones emocionales negativas ante la imposibilidad de usar la tecnología o ante un tiempo considerable sin poder usarla (síndrome de abstinencia);</p>

            <p>&nbsp;c) Uso excesivo de las tecnologías que interfiere con todas las esferas de la vida de la persona;</p>

            <p>d) Dificultades para dejar la tecnología a pesar de ser consciente de las consecuencias negativas de esta conducta, &nbsp;</p>

            <p>e) Modificación del estado de ánimo como estrategia de escape aprendida para hacer frente a las dificultades inherentes a la propia vida (Griffiths, 1995; Stepien, 2014).</p>

            <p><strong>Estas preguntas te ayudaran a cuestionarte &nbsp;sobre el manejo que tenes con el &nbsp;uso de tecnología</strong></p>

            <p>1. ¿Con qué frecuencia ha revisado sus aplicaciones de chat, su correo electrónico y sus redes sociales hoy?</p>

            <p>2. ¿Le han llamado la atención en su familia por pasar mucho tiempo conectado a internet?</p>

            <p>3. ¿Se ha perdido en una conversación por estar pendiente del celular?</p>

            <p>4. ¿Dedica más horas del día a hablar con las personas virtualmente de las que gasta haciéndolo en persona?</p>

            <p>5. ¿Ha dejado de hacer cosas de su trabajo o de sus estudios por pasar tiempo en internet?</p>

            <p>6. ¿Suele utilizar el celular o algún dispositivo móvil mientras va manejando?</p>

            <p>7. Siente ansiedad durante un vuelo porque no puede usar el celular y lo primero que hace cuando aterriza el avión es encender su teléfono.</p>

            <p>8.¿Te cuesta &nbsp;trabajo permanecer sin Internet varios días seguidos?</p>

            <p>9. Si se encuentra en una reunión social y su teléfono se queda sin batería, ¿llegaría a considerar la posibilidad  de volverse a su casa?</p>

            <p>10.¿Con qué frecuencia ha intentado cortar el número de horas que pasa en el computador, el dispositivo móvil o la consola de videojuegos, sin tener éxito.</p>

            <p>11¿Te han comentado en alguna ocasión personas de tu entorno (familiares o amigos), que utilizas mucho el móvil para hablar o enviar mensajes?</p>

            <p>12.&nbsp;Si algún día no tienes el móvil ¿te sientes incómodo o como si te faltara algo muy importante?</p>

            <p>13.¿Te cuesta trabajo pasar tiempo sin consultar el WhatsApp (u otro programa similar) para comprobar si tienes nuevos mensajes?</p>

            <p>14. Se ha perdido gran parte de espectáculos o eventos por estar utilizando aplicaciones de mensajería, redes sociales o incluso por estar tomando fotografías?</p>

            <hr className="my-5" />

            <div classname="">
                <img src=".\img\recomendaciones.jpg" className="img-fluid mx-auto d-block" />
            </div>

        </div>

        <PdfFlipModal
            show={showModal}
            onHide={() => setShowModal(false)}
            pdfUrl={GUIA_PDF_URL}
            title="Guía para Familias"
        />
        </>
    )
}

export default Recomendaciones